module.exports = __webpack_public_path__ + "static/media/sanders.d3e37368.jpg";